import { Paper, Stack, Typography } from "@mui/material"
import { Dialog } from "@pharmupp/p3-front-commons"

interface CPUserCardDialogProps {
  open: boolean
  validateAction: () => void
  cancelAction: () => void
  isActivatable: boolean
  userFullName: string
  validateEnabled: boolean
  canUpdate: boolean
}

export const CPMemberCardDialog = ({
  userFullName,
  isActivatable,
  canUpdate,
  ...props
}: CPUserCardDialogProps) => {
  return (
    <Dialog
      {...props}
      sx={{ width: 540 }}
      iconSvgSrc="/icons/committee-platform.svg"
      cancelText="Annuler"
      validateText={isActivatable ? "Valider" : "Mettre à jour"}
      title={
        <Stack lineHeight={0}>
          <Typography variant="28px" fontWeight={600}>
            Accès plateforme CSE
          </Typography>
          <Typography
            variant="18px"
            fontWeight="bold"
            color="info.dark"
            marginRight={1}
          >
            pour {userFullName}
          </Typography>
          <Paper
            sx={{
              bgcolor: "common.blueWhite",
              border: 0,
              padding: 2,
              lineHeight: 0,
              marginTop: 2,
            }}
          >
            <Typography fontWeight={600} color="grey.dark" component="span">
              Pour rappel :{" "}
              <Typography fontWeight={400} component="span">
                L’ouverture de l’accès à la plateforme CSE doit être garantie à
                l’ensemble des salariés, sans distinction.
              </Typography>
            </Typography>
          </Paper>
        </Stack>
      }
    >
      <Stack textAlign="center">
        {isActivatable ? (
          <>
            <Typography>
              Vous êtes sur le point de demander l’accès CSE pour ce collaborateur.
            </Typography>
            <Typography>Êtes-vous sûr de vouloir continuer ?</Typography>
          </>
        ) : canUpdate ? (
          <>
            <Typography>
              Certaines informations personnelles obligatoires n’ont pas été
              renseignées pour ce collaborateur.
            </Typography>
            <Typography>
              Vous devez les ajouter avant de pouvoir lui ouvrir l’accès à la
              Plateforme CSE.
            </Typography>
          </>
        ) : (
          <Typography>
            La mise à jour et la création de l'accès à la Plateforme CSE sont à
            réaliser par le titulaire en personne.
          </Typography>
        )}
      </Stack>
    </Dialog>
  )
}
